export default __webpack_public_path__ + "static/media/allProducts.5e286acd.jpg";